import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Chairs",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Chairs",
    description: "Chairs",
    image: require("./Chairs.svg"),
    svgIcon: require("./Chairs.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-19, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M29.89,21.09c1.55.31,3.12.53,4.64.95a6.68,6.68,0,0,1,4,3.26q6.12,10.46,12.27,20.91c.33.56.32.94-.32,1.17-1.12.39-1.41,1.19-1.58,2.33a6.18,6.18,0,0,1-3.29,4.61q-8.13,4.62-16.27,9.24a6.72,6.72,0,0,1-6.28.31A1.81,1.81,0,0,0,21.2,64c-1.29.77-1.08.78-1.84-.51C15.5,56.91,11.7,50.29,7.76,43.76A8.6,8.6,0,0,1,7.45,35,21.55,21.55,0,0,1,15,26.57a29.16,29.16,0,0,1,12.29-5.11,3.68,3.68,0,0,1,.58-.08h2Zm-.26,3.3a22.22,22.22,0,0,0-12.87,4.33,17.37,17.37,0,0,0-6.33,7.55A7.16,7.16,0,0,0,10.59,43Q16.29,52.79,22,62.52a2.23,2.23,0,0,0,.91.81A6.3,6.3,0,0,0,29,63.2l16.48-9.4a6,6,0,0,0,3-4.59,2.73,2.73,0,0,0-.36-1.91c-3.72-6.31-7.41-12.65-11.13-19a8.52,8.52,0,0,0-1.3-1.73A8.68,8.68,0,0,0,29.63,24.39ZM21.82,63.14l-.53-.91q-5.46-9.34-10.91-18.7a8.8,8.8,0,0,1-.89-2.07,9.13,9.13,0,0,1,1.3-7A20.59,20.59,0,0,1,19,26.78,20.52,20.52,0,0,1,29.35,24c3.74,0,6.63,1.37,8.55,4.82,3.39,6.06,7,12,10.5,18l.58.94,1.51-.92a3,3,0,0,0-.2-.43L37.94,25.28a6.47,6.47,0,0,0-3.68-2.89,16.45,16.45,0,0,0-9.43,0,29.25,29.25,0,0,0-9,4.14,22,22,0,0,0-7.9,8.61c-1.29,2.69-1.54,5.33.11,8.07,3.94,6.58,7.76,13.22,11.63,19.84.19.33.39.65.62,1Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M79.87,66.16a27.43,27.43,0,0,1-4-.8C71.82,64,67.74,62.58,63.75,61a11.65,11.65,0,0,1-7-7.2,8.38,8.38,0,0,1,.16-5.35,13.1,13.1,0,0,1,4.81-7,11.19,11.19,0,0,0,4.43-7.24,17.17,17.17,0,0,1,2.59-6.41c2.7-3.85,5.8-4.93,10.27-3.45,3.29,1.1,6.56,2.27,9.78,3.54,4.49,1.76,6.37,5.27,5.28,10a24.79,24.79,0,0,1-2.11,5.79,13.16,13.16,0,0,0-1.12,9.06,11.84,11.84,0,0,1-3.22,10.81C85.69,65.46,83.15,66,79.87,66.16ZM73.31,29.34a45.52,45.52,0,0,1-5.75,14.11A35.46,35.46,0,0,1,57.48,54.52a11.34,11.34,0,0,0,6.46,6c4.19,1.64,8.44,3.15,12.71,4.55A11.88,11.88,0,0,0,85,64.71a.8.8,0,0,0,.58-1.07,34,34,0,0,1-.69-4.47,45.22,45.22,0,0,1,4.67-22.74c.17-.34.35-.67.61-1.15A38.32,38.32,0,0,1,73.31,29.34Zm20.44,6c0-.17,0-.39,0-.61a6.66,6.66,0,0,0-4.27-6c-4-1.56-8-3-12-4.31a6.73,6.73,0,0,0-7.41,2.47A47.17,47.17,0,0,0,93.75,35.38Zm-24.18-8L69.1,28a17.89,17.89,0,0,0-2.5,6.18,11.92,11.92,0,0,1-4.76,7.72,12.56,12.56,0,0,0-4.5,6.61,8.22,8.22,0,0,0,0,5.6c1.13-.92,2.2-1.72,3.17-2.61a41.21,41.21,0,0,0,8.6-11.81,40.86,40.86,0,0,0,3.56-9.83,1,1,0,0,0-.22-.9C71.54,28.39,70.56,27.9,69.57,27.36ZM86.23,64.13a14.23,14.23,0,0,0,1.82-1.85A12.94,12.94,0,0,0,90.2,51.85a16.49,16.49,0,0,1-.35-3.06c0-2.21,1.05-4.08,2-6a19.22,19.22,0,0,0,1.93-6c.06-.51,0-.79-.59-.87a15.39,15.39,0,0,1-1.89-.37.68.68,0,0,0-.92.45c-.63,1.4-1.35,2.76-1.9,4.19a46.63,46.63,0,0,0-3.16,15.52A26.46,26.46,0,0,0,86.23,64.13Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M40.23,80.15A5.52,5.52,0,0,1,36,77.72c-1.64-2.57-3.21-5.19-4.62-7.89a4.9,4.9,0,0,1,2.22-6.71c3.44-1.93,6.86-3.88,10.29-5.84a5,5,0,0,1,6.55,1.57,89.38,89.38,0,0,1,4.7,8,4.84,4.84,0,0,1-2.19,6.58c-3.39,1.9-6.74,3.87-10.15,5.76A17.77,17.77,0,0,1,40.23,80.15ZM46.12,68c-1.41.16-1.83-.37-1.44-1.8-1.22-.16-1.46-.55-1.18-1.88-1.29-.31-1.47-.63-1.1-2-1.07.09-1.36-.61-1.4-1.58l-.87.7c.82.81.84.91.57,1.8.41.27.94.43,1.12.78s0,.89,0,1.36c1.16,0,1.46.49,1.1,1.78,1.34.36,1.57.78,1.09,2,1.34.18,1.63.66,1.14,1.89,1.35.21,1.62.65,1.2,1.82.39.21.91.32,1.12.64s.14.84.19,1.21a37.74,37.74,0,0,1,4.37-1.56,4.17,4.17,0,0,0,2.66-5.82c-1.5-2.9-3.2-5.71-5-8.46a4.09,4.09,0,0,0-5.09-1.4A17.18,17.18,0,0,0,41.88,60c.47.33.95.5,1.13.84s0,.83,0,1.13c.4.26.92.43,1.1.77s0,.87,0,1.33c1.18.08,1.46.52,1.08,1.87,1.43.18,1.71.87.84,2.1Zm-6.89-1.17c-1.35.24-1.86-.4-1.46-1.64-.42-.26-1-.41-1.14-.75s0-.9,0-1.37A21.92,21.92,0,0,0,34,63.7a4.39,4.39,0,0,0-1.72,1C31,66.22,31,68.4,32.21,70.54s2.31,4,3.53,6a8.27,8.27,0,0,0,1.67,2c1.38,1.16,3.6,1.37,4.78.46,1.54-1.19,3-2.48,4.49-3.72-1.09-.55-1.2-.78-.86-2-1.27-.17-1.54-.62-1.18-1.76-.41-.25-.94-.41-1.13-.76s0-.87,0-1.32c-1.2-.14-1.51-.66-1-1.86-1.32-.27-1.56-.64-1.21-1.87-1.3-.38-1.51-.74-1.11-2-.92,0-1.35-.53-1.43-1.43l-1.17.46c1.12.65,1.21.88.84,2,1.48.35,1.73,1,.87,2.13Zm3-8.06-7,4A10.36,10.36,0,0,0,42.18,58.76Zm8.08,15.65a10,10,0,0,0-5,2.87ZM40.66,62.6c-.4-.27-.67-.58-.83-.53s-.42.39-.62.61c.21.18.42.49.63.5S40.27,62.89,40.66,62.6Zm5.71,9.61c-.37-.32-.61-.66-.78-.63a1,1,0,0,0-.63.57c0,.16.31.58.51.59S46,72.47,46.37,72.21Zm1.16,1.87c-.39-.28-.66-.6-.83-.56s-.41.4-.61.62c.2.18.4.49.62.51S47.15,74.36,47.53,74.08Zm-5.7-9.59c-.44-.27-.68-.54-.9-.52s-.54.35-.54.54.33.57.52.57S41.4,64.79,41.83,64.49Zm2.52,6.63c.31-.39.64-.63.61-.8a.89.89,0,0,0-.58-.6c-.16,0-.56.31-.57.5S44.08,70.71,44.35,71.12Zm.08-5.19c.27-.39.56-.63.54-.83s-.36-.4-.55-.59c-.21.21-.53.4-.58.65S44.14,65.57,44.43,65.93Zm-.33-2.75c-.39-.28-.63-.57-.84-.55s-.55.34-.55.53a.77.77,0,0,0,.53.56C43.45,63.75,43.69,63.45,44.1,63.18Zm-.86,4.35c-.29.36-.63.63-.58.78s.4.42.61.63c.19-.21.5-.4.52-.63S43.51,67.89,43.24,67.53Zm-1.09-1.92c-.29.36-.62.61-.59.78s.37.43.57.64c.19-.2.52-.37.55-.59S42.41,66,42.15,65.61Zm4.26,1.32c-.45-.25-.71-.51-.9-.47S45,66.83,45,67s.36.56.54.55S46,67.26,46.41,66.93Zm-4.33-4.75c.29-.45.57-.69.58-.94s-.37-.52-.56-.51a.79.79,0,0,0-.54.55C41.54,61.49,41.81,61.74,42.08,62.18Zm-2.61,3.69c-.36-.29-.61-.62-.77-.58s-.44.38-.65.58c.2.19.38.51.6.54S39.09,66.14,39.47,65.87Zm-1.14-2c-.39-.27-.65-.57-.83-.53s-.4.37-.59.58c.2.19.39.52.62.55S38,64.22,38.33,63.92Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M29.63,24.39a8.68,8.68,0,0,1,6.12,2.22,8.52,8.52,0,0,1,1.3,1.73c3.72,6.31,7.41,12.65,11.13,19a2.73,2.73,0,0,1,.36,1.91,6,6,0,0,1-3,4.59L29,63.2a6.3,6.3,0,0,1-6.11.13,2.23,2.23,0,0,1-.91-.81Q16.28,52.79,10.59,43a7.16,7.16,0,0,1-.16-6.77,17.37,17.37,0,0,1,6.33-7.55A22.22,22.22,0,0,1,29.63,24.39Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M21.82,63.14l-1.58.94c-.23-.36-.43-.68-.62-1C15.75,56.45,11.93,49.81,8,43.23c-1.65-2.74-1.4-5.38-.11-8.07a22,22,0,0,1,7.9-8.61,29.25,29.25,0,0,1,9-4.14,16.45,16.45,0,0,1,9.43,0,6.47,6.47,0,0,1,3.68,2.89L50.29,46.36a3,3,0,0,1,.2.43L49,47.71l-.58-.94c-3.51-6-7.11-11.92-10.5-18C36,25.34,33.09,24,29.35,24A20.52,20.52,0,0,0,19,26.78a20.59,20.59,0,0,0-8.23,7.69,9.13,9.13,0,0,0-1.3,7,8.8,8.8,0,0,0,.89,2.07q5.43,9.36,10.91,18.7Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M73.31,29.34A38.32,38.32,0,0,0,90.2,35.28c-.26.48-.44.81-.61,1.15a45.22,45.22,0,0,0-4.67,22.74,34,34,0,0,0,.69,4.47A.8.8,0,0,1,85,64.71a11.88,11.88,0,0,1-8.38.39c-4.27-1.4-8.52-2.91-12.71-4.55a11.34,11.34,0,0,1-6.46-6A35.46,35.46,0,0,0,67.56,43.45,45.52,45.52,0,0,0,73.31,29.34Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M93.75,35.38A47.17,47.17,0,0,1,70.06,26.9a6.73,6.73,0,0,1,7.41-2.47c4,1.3,8,2.75,12,4.31a6.66,6.66,0,0,1,4.27,6C93.76,35,93.75,35.21,93.75,35.38Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M69.57,27.36c1,.54,2,1,2.89,1.61a1,1,0,0,1,.22.9,40.86,40.86,0,0,1-3.56,9.83,41.21,41.21,0,0,1-8.6,11.81c-1,.89-2,1.69-3.17,2.61a8.22,8.22,0,0,1,0-5.6,12.56,12.56,0,0,1,4.5-6.61,11.92,11.92,0,0,0,4.76-7.72A17.89,17.89,0,0,1,69.1,28Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M86.23,64.13a26.46,26.46,0,0,1-1-8.45,46.63,46.63,0,0,1,3.16-15.52c.55-1.43,1.27-2.79,1.9-4.19a.68.68,0,0,1,.92-.45,15.39,15.39,0,0,0,1.89.37c.55.08.65.36.59.87a19.22,19.22,0,0,1-1.93,6c-.91,1.91-2,3.78-2,6a16.49,16.49,0,0,0,.35,3.06,12.94,12.94,0,0,1-2.15,10.43A14.23,14.23,0,0,1,86.23,64.13Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M39.21,66.83c.86-1.18.61-1.78-.87-2.13.37-1.08.28-1.31-.84-2l1.17-.46c.08.9.51,1.44,1.43,1.43-.4,1.24-.19,1.6,1.11,2-.35,1.23-.11,1.6,1.21,1.87-.46,1.2-.15,1.72,1,1.86,0,.45-.15,1,0,1.32s.72.51,1.13.76c-.36,1.14-.09,1.59,1.18,1.76-.34,1.21-.23,1.44.86,2-1.48,1.24-3,2.53-4.49,3.72-1.18.91-3.4.7-4.78-.46a8.27,8.27,0,0,1-1.67-2c-1.22-2-2.38-4-3.53-6s-1.23-4.32.09-5.79a4.39,4.39,0,0,1,1.72-1,21.92,21.92,0,0,1,2.57-.64c0,.47-.15,1,0,1.37s.72.49,1.14.75c-.4,1.24.11,1.88,1.46,1.64-.89,1.09-.6,1.78.89,2.08-.45,1.17-.14,1.69.92,1.86.11.57.06,1.23.36,1.53s.94.15,1.43.2A1,1,0,0,0,42.32,74a1,1,0,0,0,1.47.45,4.73,4.73,0,0,0-.35.56,1.05,1.05,0,1,0,1.06-.57,3.72,3.72,0,0,0-.74,0,1,1,0,0,0,.4-1.39,1.06,1.06,0,0,0-1.35-.54c.59-1.31.38-1.72-1-2,.39-1.24.17-1.61-1.15-2C41.09,67.18,40.6,66.61,39.21,66.83Zm1,7.19c-.66,1.1-.34,1.7,1.05,2-.39,1-.25,1.48.45,1.75a1,1,0,0,0,1.33-.64c.06-.23.1-.59,0-.71a9.58,9.58,0,0,0-1.22-.89c.39-1.23-.06-1.77-1.42-1.62.34-.45.7-.91.29-1.48A1.1,1.1,0,0,0,39.22,72c.84-1.25.59-1.87-.86-2.13.37-1.34.12-1.72-1.22-1.87.51-1.25.22-1.74-1.14-2,.38-.95.24-1.5-.45-1.74a1,1,0,0,0-1.33.64c-.06.25-.07.64.08.78a7.29,7.29,0,0,0,1.2.78c-.42,1.07-.08,1.62,1.17,1.79-.45,1.21-.25,1.55,1.13,2-.47,1.27,0,1.87,1.44,1.74-.16.42-.5.87-.42,1.24C39,73.94,39.62,74,40.23,74Zm-3.52-.49c-.73,1-.38,1.68,1,2-.48,1.17-.24,1.57,1.16,2-.33.52-.46,1.1.11,1.47a1.38,1.38,0,0,0,1.18.12,1.21,1.21,0,0,0,.5-1c-.06-.74-.67-.93-1.35-.9.48-1.28.24-1.7-1.11-2,.45-1.37,0-2-1.36-1.74.77-1.27.47-1.89-.85-2,0-.45.15-1,0-1.31s-.74-.52-1.15-.78c.39-1.14.11-1.57-1.22-1.75.39-1,.2-1.63-.53-1.83a1,1,0,0,0-1.28.76c-.17.72.3,1.21,1.19,1.36,0,.48-.09,1,.12,1.34s.74.46,1.14.69c-.42,1-.13,1.54,1.15,1.83C34.93,73,35.25,73.39,36.71,73.53Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M46.1,68c.87-1.23.59-1.92-.84-2.1.38-1.35.1-1.79-1.08-1.87,0-.46.15-1,0-1.33s-.7-.51-1.1-.77c0-.3.14-.8,0-1.13s-.66-.51-1.13-.84a17.18,17.18,0,0,1,2.8-2.49,4.09,4.09,0,0,1,5.09,1.4c1.76,2.75,3.46,5.56,5,8.46a4.17,4.17,0,0,1-2.66,5.82,37.74,37.74,0,0,0-4.37,1.56c-.05-.37,0-.89-.19-1.21s-.73-.43-1.12-.64c.42-1.17.15-1.61-1.2-1.82.49-1.23.2-1.71-1.14-1.89.48-1.21.25-1.63-1.09-2,.36-1.29.06-1.73-1.1-1.78,0-.47.15-1,0-1.36s-.71-.51-1.12-.78c.27-.89.25-1-.57-1.8l.87-.7c0,1,.33,1.67,1.4,1.58-.37,1.35-.19,1.67,1.1,2-.28,1.33,0,1.72,1.18,1.88-.39,1.43,0,2,1.44,1.8-.87,1.08-.58,1.76.67,2,.1.56,0,1.18.31,1.46s.87.19,1.33.26c-.11.16-.3.31-.32.47a1.74,1.74,0,0,0,0,1.07,1.13,1.13,0,0,0,.94.48A1.4,1.4,0,0,0,50,73c.35-.83-.42-1.42-1.51-1.21.12-.44.45-1,.31-1.29s-.72-.66-1-.89c-.1-.49,0-1.09-.32-1.35S46.56,68.08,46.1,68Zm3.32-4.54c.17-.42.57-.95.44-1.24s-.76-.7-1.22-1.08c.38-1,.08-1.52-1.22-1.7.42-1,.3-1.54-.4-1.8a1,1,0,0,0-1.36.61c-.25.67.18,1.18,1.28,1.53-.48,1.13-.18,1.65,1.1,1.89-.42,1.37,0,1.93,1.4,1.77-.14.4-.51.92-.38,1.17.23.45.78.72,1.23,1.1-.38,1-.17,1.34,1.21,1.74-.43,1.14-.11,1.67,1.14,1.88-.35,1-.17,1.55.56,1.78a1,1,0,0,0,1.27-.75c.05-.25,0-.65-.12-.78a6.42,6.42,0,0,0-1.21-.68c.5-1,.25-1.5-1.11-1.87.39-1.21.15-1.62-.94-1.84-.1-.56,0-1.18-.32-1.48S49.89,63.54,49.42,63.47Zm-.92,3.08c-1,1.13-.69,1.87.66,2.14,0,.49-.07,1,.14,1.34s.74.46,1.14.68c-.35.87-.13,1.51.61,1.72a1.09,1.09,0,0,0,1.26-.83c.14-.7-.35-1.17-1.35-1.31.42-1.23.23-1.58-1.11-2,.4-1.32,0-1.85-1.39-1.75.8-1.16.5-1.81-.92-2,.41-1.29.14-1.74-1.09-1.9,0-.46.16-1,0-1.32s-.77-.48-1.19-.72c.37-.8.21-1.43-.47-1.68a1,1,0,0,0-1.33.67,1,1,0,0,0,.09.79,6.71,6.71,0,0,0,1.18.78c-.42,1.08-.2,1.45,1.15,1.82-.4,1.18-.1,1.66.95,1.83.12.58.07,1.21.37,1.53S48,66.5,48.5,66.55Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M42.18,58.76a10.36,10.36,0,0,1-7,4Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M50.26,74.41l-5,2.87A10,10,0,0,1,50.26,74.41Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M40.66,62.6c-.39.29-.61.59-.82.58s-.42-.32-.63-.5c.2-.22.37-.54.62-.61S40.26,62.33,40.66,62.6Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M46.37,72.21c-.41.26-.67.55-.9.53s-.55-.43-.51-.59a1,1,0,0,1,.63-.57C45.76,71.55,46,71.89,46.37,72.21Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M47.53,74.08c-.38.28-.61.58-.82.57s-.42-.33-.62-.51c.2-.22.37-.55.61-.62S47.14,73.8,47.53,74.08Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M41.83,64.49c-.43.3-.68.59-.92.59s-.51-.36-.52-.57.33-.51.54-.54S41.39,64.22,41.83,64.49Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M44.35,71.12c-.27-.41-.56-.66-.54-.9s.41-.54.57-.5a.89.89,0,0,1,.58.6C45,70.49,44.66,70.73,44.35,71.12Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M44.43,65.93c-.29-.36-.63-.61-.59-.77s.37-.44.58-.65c.19.19.52.37.55.59S44.7,65.54,44.43,65.93Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M44.1,63.18c-.41.27-.65.57-.86.54a.77.77,0,0,1-.53-.56c0-.19.34-.51.55-.53S43.71,62.9,44.1,63.18Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M43.24,67.53c.27.36.57.59.55.78s-.33.42-.52.63c-.21-.21-.53-.38-.61-.63S43,67.89,43.24,67.53Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M42.15,65.61c.26.39.55.63.53.83s-.36.39-.55.59c-.2-.21-.52-.4-.57-.64S41.86,66,42.15,65.61Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M46.41,66.93c-.42.33-.65.63-.89.64S45,67.23,45,67s.31-.52.53-.56S46,66.68,46.41,66.93Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M42.08,62.18c-.27-.44-.54-.69-.52-.9a.79.79,0,0,1,.54-.55c.19,0,.57.33.56.51S42.37,61.73,42.08,62.18Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M39.47,65.87c-.38.27-.62.56-.82.54s-.4-.35-.6-.54c.21-.2.4-.52.65-.58S39.11,65.58,39.47,65.87Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M38.33,63.92c-.37.3-.61.62-.8.6s-.42-.36-.62-.55c.19-.21.36-.54.59-.58S37.94,63.65,38.33,63.92Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M36.71,73.53c-1.46-.14-1.78-.58-1.33-1.86-1.28-.29-1.57-.78-1.15-1.83-.4-.23-.93-.36-1.14-.69S33,68.29,33,67.81c-.89-.15-1.36-.64-1.19-1.36a1,1,0,0,1,1.28-.76c.73.2.92.86.53,1.83,1.33.18,1.61.61,1.22,1.75.41.26.94.43,1.15.78s0,.86,0,1.31c1.32.15,1.62.77.85,2Zm-.77-3c-.39-.31-.64-.64-.81-.6a.93.93,0,0,0-.59.6c0,.14.33.55.51.55S35.54,70.82,35.94,70.55Zm-.56,1.93c.4.25.65.53.86.5s.41-.34.61-.53c-.22-.2-.42-.52-.67-.57S35.76,72.18,35.38,72.48ZM32.83,65.8c-.31.44-.6.68-.6.92a.77.77,0,0,0,.56.53c.19,0,.5-.33.54-.55S33.09,66.24,32.83,65.8Zm1.94,2.85c-.37-.29-.61-.63-.79-.6s-.43.37-.65.57c.2.2.38.51.61.54S34.38,68.9,34.77,68.65Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M39.24,72c-1.41.13-1.91-.47-1.44-1.74-1.38-.41-1.58-.75-1.13-2-1.25-.17-1.59-.72-1.17-1.79a7.29,7.29,0,0,1-1.2-.78c-.15-.14-.14-.53-.08-.78a1,1,0,0,1,1.33-.64c.69.24.83.79.45,1.74,1.36.23,1.65.72,1.14,2,1.34.15,1.59.53,1.22,1.87,1.45.26,1.7.88.86,2.13Zm.27-1c-.41-.29-.67-.61-.84-.57a.92.92,0,0,0-.59.61c0,.15.34.54.54.55S39.1,71.31,39.51,71ZM36,65.36c-.34-.3-.58-.65-.76-.63s-.46.36-.69.55c.2.2.37.54.59.57S35.66,65.6,36,65.36Zm.38,1c-.32.43-.62.66-.62.9s.34.54.54.54.51-.31.56-.53S36.67,66.77,36.42,66.31Zm1.91,2.85c-.36-.29-.6-.64-.77-.6s-.45.37-.67.57c.2.19.39.51.61.54S37.94,69.41,38.33,69.16Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M39.21,66.83c1.39-.22,1.88.35,1.44,1.69,1.32.34,1.54.71,1.15,2,1.39.32,1.6.73,1,2l0,0c-.49,0-1.15.07-1.43-.2s-.25-1-.36-1.53c-1.06-.17-1.37-.69-.92-1.86-1.49-.3-1.78-1-.89-2.08Zm3.73,4.83c-.36-.3-.6-.65-.79-.63s-.45.37-.68.58c.21.19.4.52.63.55S42.56,71.9,42.94,71.66ZM41,68.8c-.31.4-.63.65-.6.83s.37.44.57.66c.2-.19.56-.38.56-.58S41.24,69.22,41,68.8Zm-.36-1c-.36-.29-.58-.6-.79-.59s-.42.32-.63.5c.2.22.37.54.62.62S40.25,68.06,40.62,67.8Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M36.71,73.53l.14-.13c1.34-.23,1.81.37,1.36,1.74,1.35.27,1.59.69,1.11,2,.68,0,1.29.16,1.35.9a1.21,1.21,0,0,1-.5,1A1.38,1.38,0,0,1,39,78.9c-.57-.37-.44-1-.11-1.47-1.4-.38-1.64-.78-1.16-2C36.33,75.21,36,74.55,36.71,73.53Zm1.54.82c-.41-.29-.65-.58-.89-.58s-.41.35-.61.54c.22.21.41.53.66.58S37.85,74.62,38.25,74.35Zm1.17,1.88c-.46-.27-.72-.51-1-.52s-.36.32-.54.5c.21.21.4.53.66.6S39,76.53,39.42,76.23Zm1.09,2c-.36-.32-.59-.68-.76-.65s-.46.36-.69.56c.2.19.37.51.59.55S40.11,78.48,40.51,78.25Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M40.39,73.87c1.36-.15,1.81.39,1.42,1.62a9.58,9.58,0,0,1,1.22.89c.13.12.09.48,0,.71a1,1,0,0,1-1.33.64c-.7-.27-.84-.8-.45-1.75-1.39-.26-1.71-.86-1.05-2ZM41,74c-.31.35-.66.6-.62.76s.37.44.58.66c.19-.2.52-.37.55-.59S41.25,74.41,41,74Zm1.93,2.74c-.39-.27-.63-.57-.84-.55a.8.8,0,0,0-.54.55.77.77,0,0,0,.54.55C42.3,77.33,42.54,77,42.93,76.76Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M43.76,74.44a3.72,3.72,0,0,1,.74,0,1,1,0,0,1,.91,1.25,1,1,0,1,1-2-.68,4.73,4.73,0,0,1,.35-.56Zm.63,1.82c.27-.36.57-.58.56-.79s-.32-.41-.5-.62c-.23.2-.56.36-.63.6S44.11,75.89,44.39,76.26Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M40.39,73.87l-.16.15c-.61,0-1.28-.08-1.41-.76-.08-.37.26-.82.42-1.24l0,0a1.1,1.1,0,0,1,1.46.35C41.09,73,40.73,73.42,40.39,73.87Zm-.55-.1c.25-.38.54-.63.51-.83s-.35-.4-.54-.6c-.21.22-.52.41-.58.66S39.54,73.41,39.84,73.77Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M43.76,74.44l0,0A1,1,0,0,1,42.32,74a1,1,0,0,1,.51-1.47l0,0a1.07,1.07,0,0,1,1.36.54A1,1,0,0,1,43.76,74.44Zm.33-.83c-.35-.34-.58-.7-.76-.68s-.49.34-.73.53c.18.22.34.6.55.63S43.67,73.84,44.09,73.61Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M48.5,66.55c-.46,0-1.11.07-1.34-.19s-.25-1-.37-1.53c-1-.17-1.35-.65-.95-1.83-1.35-.37-1.57-.74-1.15-1.82a6.71,6.71,0,0,1-1.18-.78,1,1,0,0,1-.09-.79,1,1,0,0,1,1.33-.67c.68.25.84.88.47,1.68.42.24,1,.38,1.19.72s0,.86,0,1.32c1.23.16,1.5.61,1.09,1.9,1.42.2,1.72.85.92,2ZM45.23,60c-.37-.29-.59-.61-.79-.6s-.44.32-.66.5c.2.22.37.55.62.63S44.84,60.21,45.23,60Zm2.27,3.8c-.35-.28-.57-.59-.77-.58s-.61.37-.59.53a1,1,0,0,0,.57.64C46.87,64.38,47.14,64,47.5,63.75Zm1.24,1.93c-.44-.29-.69-.57-.93-.57a.76.76,0,0,0-.51.56.81.81,0,0,0,.55.54C48.06,66.24,48.3,66,48.74,65.68ZM45.51,61c-.26.38-.55.62-.53.83s.36.4.55.59c.2-.21.52-.4.57-.64S45.8,61.37,45.51,61Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M49.42,63.47c.47.07,1.09,0,1.35.25s.22.92.32,1.48c1.09.22,1.33.63.94,1.84,1.36.37,1.61.84,1.11,1.87a6.42,6.42,0,0,1,1.21.68c.16.13.17.53.12.78a1,1,0,0,1-1.27.75c-.73-.23-.91-.78-.56-1.78-1.25-.21-1.57-.74-1.14-1.88-1.38-.4-1.59-.76-1.21-1.74-.45-.38-1-.65-1.23-1.1-.13-.25.24-.77.38-1.17Zm1.71,1.93c-.27.45-.54.71-.5.91a.83.83,0,0,0,.56.55.8.8,0,0,0,.57-.54C51.75,66.08,51.45,65.84,51.13,65.4Zm3.24,4.72c-.44-.28-.69-.54-1-.57s-.37.33-.56.51c.21.21.4.55.64.61S53.94,70.4,54.37,70.12ZM50,65.2c.28-.36.57-.58.57-.79s-.32-.41-.49-.62c-.22.2-.56.36-.63.6S49.75,64.82,50,65.2Zm3.19,3c-.42-.28-.66-.56-.86-.54a.77.77,0,0,0-.55.53c0,.2.31.59.48.59S52.77,68.49,53.21,68.2Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M48.5,66.55l0,0c1.37-.1,1.79.43,1.39,1.75,1.34.39,1.53.74,1.11,2,1,.14,1.49.61,1.35,1.31a1.09,1.09,0,0,1-1.26.83c-.74-.21-1-.85-.61-1.72-.4-.22-.93-.34-1.14-.68s-.1-.85-.14-1.34C47.81,68.42,47.54,67.68,48.5,66.55Zm2.8,5.7c.27-.39.6-.65.55-.83s-.4-.41-.62-.62c-.18.22-.5.42-.51.65S51,71.88,51.3,72.25Zm-3.18-4.66c.44.28.68.56.88.53s.55-.35.55-.55A.79.79,0,0,0,49,67C48.79,67,48.55,67.29,48.12,67.59Zm2.9,2c-.41-.31-.63-.6-.88-.62s-.55.33-.55.52a.8.8,0,0,0,.52.57C50.32,70.07,50.58,69.8,51,69.56Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M49.44,63.45c-1.37.16-1.82-.4-1.4-1.77-1.28-.24-1.58-.76-1.1-1.89-1.1-.35-1.53-.86-1.28-1.53A1,1,0,0,1,47,57.65c.7.26.82.83.4,1.8,1.3.18,1.6.66,1.22,1.7.46.38,1,.65,1.22,1.08s-.27.82-.44,1.24Zm-.56-1.87c-.29.44-.58.69-.55.89a.81.81,0,0,0,.55.56.77.77,0,0,0,.57-.52C49.46,62.27,49.17,62,48.88,61.58Zm-.29-1c-.37-.29-.62-.64-.79-.6s-.44.39-.65.6c.2.19.39.5.62.52S48.21,60.84,48.59,60.58ZM47.5,58.65c-.36-.28-.61-.61-.78-.57s-.43.37-.65.57c.2.19.38.51.59.53S47.11,58.91,47.5,58.65Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M48.43,71.74c-.46-.07-1.07,0-1.33-.26s-.21-.9-.31-1.46c-1.25-.27-1.54-1-.67-2l0,0c.46.07,1.06,0,1.34.26s.22.86.32,1.35c.28.23.83.48,1,.89s-.19.85-.31,1.29Zm-1.77-2c.29-.38.58-.6.57-.81s-.31-.41-.48-.62c-.22.2-.54.37-.61.61S46.4,69.37,46.66,69.76Zm2,1.08c-.37-.27-.59-.56-.8-.56s-.41.31-.62.48c.19.22.36.55.6.61S48.3,71.11,48.68,70.84Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              d="M48.43,71.74l0,.06c1.09-.21,1.86.38,1.51,1.21a1.4,1.4,0,0,1-.87.75,1.13,1.13,0,0,1-.94-.48,1.74,1.74,0,0,1,0-1.07C48.13,72.05,48.32,71.9,48.43,71.74Zm1.38,1c-.37-.27-.63-.59-.79-.55s-.41.39-.61.61c.2.18.4.5.61.51S49.45,73,49.81,72.73Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M35.94,70.55c-.4.27-.65.55-.89.55s-.54-.41-.51-.55a.93.93,0,0,1,.59-.6C35.3,69.91,35.55,70.24,35.94,70.55Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M35.38,72.48c.38-.3.62-.63.8-.6s.45.37.67.57c-.2.19-.39.51-.61.53S35.78,72.73,35.38,72.48Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M32.83,65.8c.26.44.53.69.5.9s-.35.55-.54.55a.77.77,0,0,1-.56-.53C32.23,66.48,32.52,66.24,32.83,65.8Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M34.77,68.65c-.39.25-.63.54-.83.51s-.41-.34-.61-.54c.22-.2.41-.52.65-.57S34.4,68.36,34.77,68.65Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M39.51,71c-.41.29-.65.59-.89.59s-.57-.4-.54-.55a.92.92,0,0,1,.59-.61C38.84,70.41,39.1,70.73,39.51,71Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M36,65.36c-.38.24-.64.52-.86.49s-.39-.37-.59-.57c.23-.19.44-.52.69-.55S35.7,65.06,36,65.36Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M36.42,66.31c.25.46.51.71.48.91s-.37.54-.56.53-.55-.35-.54-.54S36.1,66.74,36.42,66.31Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M38.33,69.16c-.39.25-.63.53-.83.51s-.41-.35-.61-.54c.22-.2.42-.52.67-.57S38,68.87,38.33,69.16Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M42.94,71.66c-.38.24-.64.53-.84.5s-.42-.36-.63-.55c.23-.21.43-.53.68-.58S42.58,71.36,42.94,71.66Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M41,68.8c.26.42.54.67.53.91s-.36.39-.56.58c-.2-.22-.52-.42-.57-.66S40.67,69.2,41,68.8Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M40.62,67.8c-.37.26-.65.58-.8.53s-.42-.4-.62-.62c.21-.18.42-.49.63-.5S40.26,67.51,40.62,67.8Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M38.25,74.35c-.4.27-.66.58-.84.54s-.44-.37-.66-.58c.2-.19.4-.54.61-.54S37.84,74.06,38.25,74.35Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M39.42,76.23c-.42.3-.69.62-.86.58s-.45-.39-.66-.6c.18-.18.37-.51.54-.5S39,76,39.42,76.23Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M40.51,78.25c-.4.23-.66.5-.86.46s-.39-.36-.59-.55c.23-.2.44-.51.69-.56S40.15,77.93,40.51,78.25Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M41,74c.25.39.54.63.51.83s-.36.39-.55.59c-.21-.22-.53-.41-.58-.66S40.69,74.37,41,74Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M42.93,76.76c-.39.27-.63.57-.84.55a.77.77,0,0,1-.54-.55.8.8,0,0,1,.54-.55C42.3,76.19,42.54,76.49,42.93,76.76Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M44.39,76.26c-.28-.37-.61-.64-.57-.81s.4-.4.63-.6c.18.21.49.41.5.62S44.66,75.9,44.39,76.26Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M39.84,73.77c-.3-.36-.64-.61-.61-.77s.37-.44.58-.66c.19.2.51.38.54.6S40.09,73.39,39.84,73.77Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M44.09,73.61c-.42.23-.7.51-.94.48s-.37-.41-.55-.63c.24-.19.47-.51.73-.53S43.74,73.27,44.09,73.61Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M45.23,60c-.39.26-.67.58-.83.53s-.42-.41-.62-.63c.22-.18.43-.48.66-.5S44.86,59.66,45.23,60Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M47.5,63.75c-.36.28-.63.63-.79.59a1,1,0,0,1-.57-.64c0-.16.37-.51.59-.53S47.15,63.47,47.5,63.75Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M48.74,65.68c-.44.28-.68.56-.89.53a.81.81,0,0,1-.55-.54.76.76,0,0,1,.51-.56C48.05,65.11,48.3,65.39,48.74,65.68Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M45.51,61c.29.36.62.6.59.78s-.37.43-.57.64c-.19-.19-.52-.37-.55-.59S45.25,61.39,45.51,61Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M51.13,65.4c.32.44.62.68.63.92a.8.8,0,0,1-.57.54.83.83,0,0,1-.56-.55C50.59,66.11,50.86,65.85,51.13,65.4Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M54.37,70.12c-.43.28-.7.6-.88.55s-.43-.4-.64-.61c.19-.18.39-.52.56-.51S53.93,69.84,54.37,70.12Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M50,65.2c-.27-.38-.59-.65-.55-.81s.41-.4.63-.6c.17.21.48.41.49.62S50.3,64.84,50,65.2Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M53.21,68.2c-.44.29-.68.57-.93.58s-.49-.39-.48-.59a.77.77,0,0,1,.55-.53C52.55,67.64,52.79,67.92,53.21,68.2Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M51.3,72.25c-.28-.37-.59-.59-.58-.8s.33-.43.51-.65c.22.21.56.38.62.62S51.57,71.86,51.3,72.25Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M48.12,67.59c.43-.3.67-.59.91-.59a.79.79,0,0,1,.52.57c0,.2-.33.52-.55.55S48.56,67.87,48.12,67.59Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M51,69.56c-.44.24-.7.51-.91.47a.8.8,0,0,1-.52-.57c0-.19.37-.54.55-.52S50.61,69.25,51,69.56Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M48.88,61.58c.29.44.58.69.57.93a.77.77,0,0,1-.57.52.81.81,0,0,1-.55-.56C48.3,62.27,48.59,62,48.88,61.58Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M48.59,60.58c-.38.26-.62.55-.82.52s-.42-.33-.62-.52c.21-.21.4-.54.65-.6S48.22,60.29,48.59,60.58Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M47.5,58.65c-.39.26-.62.55-.84.53s-.39-.34-.59-.53c.22-.2.4-.53.65-.57S47.14,58.37,47.5,58.65Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M46.66,69.76c-.26-.39-.57-.65-.52-.82s.39-.41.61-.61c.17.21.48.41.48.62S47,69.38,46.66,69.76Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M48.68,70.84c-.38.27-.65.58-.82.53s-.41-.39-.6-.61c.21-.17.41-.47.62-.48S48.31,70.57,48.68,70.84Z"
              transform="translate(-6.4 -21.09)"
            />
            <path
              class="cls-1"
              d="M49.81,72.73c-.36.28-.59.58-.79.57s-.41-.33-.61-.51c.2-.22.37-.55.61-.61S49.44,72.46,49.81,72.73Z"
              transform="translate(-6.4 -21.09)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
